export const columns = [
    {
        id: 'tradeId',
        title: 'Trade ID'
    },
    {
        id: 'prodClass',
        title: 'Prod Class'
    },
    {
        id: 'imModel',
        title: 'IM Model'
    },
    {
        id: 'riskType',
        title: 'Risk Type'
    },
    {
        id: 'qualifier',
        title: 'Qualifier'
    },
    {
        id: 'labelOne',
        title: 'Label 1'
    },
    {
        id: 'labelTwo',
        title: 'Label 2'
    },
    {
        id: 'bucket',
        title: 'Bucket'
    },
    {
        id: 'endDate',
        title: 'End Date'
    },
    {
        id: 'amountCcy',
        title: 'Amount CCY'
    },
    {
        id: 'amount',
        title: 'Amount'
    },
    {
        id: 'amountUsd',
        title: 'Amount (USD)'
    },
    {
        id: 'deleteRow',
        title: ''
    }
];

export const defaultRow = {
    tradeId: '',
    prodClass: '',
    imModel: '',
    riskType: '',
    date: '',
    qualifier: '',
    labelOne: '',
    labelTwo: '',
    bucket: '',
    amountCcy: '',
    amount: '',
    amountUsd: '',
    deleteRow: ''
};
